import * as i0 from '@angular/core';
import { Injectable, PLATFORM_ID, Component, ChangeDetectionStrategy, Inject, Input, ViewChild, NgModule } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import * as i2 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
const _c0 = ["carouselContainer"];
const _c1 = ["*"];
function CarouselComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "button", 8);
    i0.ɵɵlistener("click", function CarouselComponent_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.slider == null ? null : ctx_r2.slider.prev());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 9);
    i0.ɵɵelement(3, "path", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "button", 11);
    i0.ɵɵlistener("click", function CarouselComponent_Conditional_3_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.slider == null ? null : ctx_r2.slider.next());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 9);
    i0.ɵɵelement(6, "path", 12);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r2.infinite && ((ctx_r2.slider == null ? null : ctx_r2.slider.currentSlide) === 0 && ((ctx_r2.slider == null ? null : ctx_r2.slider.currentTranslation) || 0) >= 0 || (ctx_r2.carousel == null ? null : ctx_r2.carousel.numberDots) === 1));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r2.infinite && ((ctx_r2.slider == null ? null : ctx_r2.slider.currentSlide) === ((ctx_r2.carousel == null ? null : ctx_r2.carousel.numberDots) || 0) - 1 && ((ctx_r2.slider == null ? null : ctx_r2.slider.currentTranslation) || 0) <= -((ctx_r2.carousel == null ? null : ctx_r2.carousel.maxScrollableContent) || 0) || (ctx_r2.carousel == null ? null : ctx_r2.carousel.numberDots) === 1));
  }
}
function CarouselComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "button", 13);
    i0.ɵɵlistener("click", function CarouselComponent_Conditional_4_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.slider == null ? null : ctx_r2.slider.launchAutoPlay());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 14);
    i0.ɵɵelement(3, "path", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "button", 16);
    i0.ɵɵlistener("click", function CarouselComponent_Conditional_4_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.slider == null ? null : ctx_r2.slider.stopAutoPlay());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 17);
    i0.ɵɵelement(6, "path", 18);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", (ctx_r2.slider == null ? null : ctx_r2.slider.playActive) || (ctx_r2.slider == null ? null : ctx_r2.slider.playButtonDisabled));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !(ctx_r2.slider == null ? null : ctx_r2.slider.playActive));
  }
}
function CarouselComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", ((ctx_r2.slider == null ? null : ctx_r2.slider.currentSlide) || 0) + 1, " ", ctx_r2.counterSeparator, " ", ctx_r2.carousel == null ? null : ctx_r2.carousel.numberDots, " ");
  }
}
function CarouselComponent_Conditional_8_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function CarouselComponent_Conditional_8_button_1_Template_button_click_0_listener() {
      const bullet_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.slider == null ? null : ctx_r2.slider.goTo(bullet_r6));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const bullet_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("current", bullet_r6 === (ctx_r2.slider == null ? null : ctx_r2.slider.currentSlide));
  }
}
function CarouselComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, CarouselComponent_Conditional_8_button_1_Template, 1, 2, "button", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.carousel == null ? null : ctx_r2.carousel.arrayNumberDots);
  }
}
class Carousel {
  constructor(carousel, maxWidthCarousel, slideToShow, slideWidth, slideMaxWidth, gap, responsive, loop) {
    this.carousel = carousel;
    this.maxWidthCarousel = maxWidthCarousel;
    this.slideToShow = slideToShow;
    this.slideWidth = slideWidth;
    this.slideMaxWidth = slideMaxWidth;
    this.gap = gap;
    this.responsive = responsive;
    this.loop = loop;
    this.arrayNumberDots = [];
    this.maxScrollableContent = 0;
    this.totalSlides = 0;
    this.initialSlideToShow = 1;
    this.paddingCarousel = 0;
    this.arrayOfSlides = [];
    this.init();
  }
  init() {
    this.paddingCarousel = this.getPaddingCarousel();
    this.initialSlideToShow = this.slideToShow;
    this.slidesContainer = this.selectSlidesContainer();
    this.slides = this.selectSlides();
    this.arrayOfSlides = this.slidesToArray();
    this.totalSlides = this.slides.length;
    this.originalSlideWidth = this.slideWidth;
    this.setWidthSlides();
    this.setMaxWidthCarousel();
    this.updateProperties();
    this.slidesContainer.style.gap = `${this.gap}px`;
    this.setDraggableImgToFalse();
  }
  /**
   * Set the slide width and max width
   * NB: In responsive mode, width is automatically adapted through the setAutoColumnSlideContainer() method.
   *
   */
  setWidthSlides() {
    for (const slide of this.slides) {
      slide.style.maxWidth = `${this.slideMaxWidth}px`;
      slide.style.width = '100%';
      slide.style.userSelect = 'none';
      if (!this.responsive) {
        slide.style.width = `${this.slideWidth}px`;
      }
    }
  }
  /**
   * Update carousel properties
   * Occurs at start and at resizing.
   */
  updateProperties() {
    this.carouselWidth = this.carousel.clientWidth;
    if (this.responsive) {
      this.updateSlideToShowResponsive();
      this.setAutoColumnSlideContainer();
    } else {
      this.updateSlideToShowNotResponsive();
    }
    this.numberDots = this.setNumberDots();
    this.arrayNumberDots = [...Array(this.numberDots).keys()];
    this.slideWidthWithGap = this.slideWidth + this.gap;
    this.setWidthSlideContainer();
    this.maxScrollableContent = this.getMaxScroll();
  }
  /**
   * Update slide to show (responsive mode)
   * Computes the number of slide fitting
   */
  updateSlideToShowResponsive() {
    const slideWidthPlusGap = this.originalSlideWidth + this.gap;
    const referenceWidth = Math.min(this.carouselWidth, this.maxWidthCarousel || Infinity, window.innerWidth);
    const slideFitting = Math.floor(referenceWidth / slideWidthPlusGap) || 1;
    this.determineSlideToShow(slideFitting);
  }
  /**
   * Determine slide to show
   * Useful to compute the slide displayed on screen and for the slider class.
   * In not responsive mode, the maximum slides to show is determined by the maximum available space and the width of the slide set by the user.
   */
  determineSlideToShow(slideFitting) {
    const maxSlidesToShow = this.responsive ? this.initialSlideToShow : this.totalSlides;
    this.slideToShow = Math.min(slideFitting, maxSlidesToShow);
  }
  /**
   * Update slide to show (not responsive mode)
   * Computes the number of slide fitting. The number of slides to be shown are determined by the number of slides fitting within its container.
   */
  updateSlideToShowNotResponsive() {
    const slideWidthPlusGap = this.slideWidth + this.gap;
    const referenceWidth = Math.min(this.carouselWidth, this.maxWidthCarousel || Infinity, window.innerWidth);
    const numberOfSlidesComputed = Math.floor(referenceWidth / slideWidthPlusGap) || 1;
    const slideFitting = Math.min(numberOfSlidesComputed, this.totalSlides);
    this.determineSlideToShow(slideFitting);
  }
  getPaddingCarousel() {
    const computedStyle = window.getComputedStyle(this.carousel);
    const paddingLeft = computedStyle.getPropertyValue('padding-left');
    const paddingRight = computedStyle.getPropertyValue('padding-right');
    return parseFloat(paddingLeft) + parseFloat(paddingRight);
  }
  setMaxWidthCarousel() {
    this.carousel.style.maxWidth = `${this.maxWidthCarousel}px`;
  }
  /**
   * Set the with of a slide, responsive mode
   * There are [n cards - 1] gaps (3 cards, 2 gaps)
   */
  setAutoColumnSlideContainer() {
    const windowWidth = this.carouselWidth - this.paddingCarousel - (this.slideToShow - 1) * this.gap;
    const widthPerSlide = windowWidth / this.slideToShow;
    this.slidesContainer.style.gridAutoColumns = `${widthPerSlide}px`;
    this.slideWidth = widthPerSlide;
  }
  /**
   * Define the slide container width
   * Make non visible gaps of non visible cards scrollable and is used to compute the maxScrollableContent (strechingEffect)
   */
  setWidthSlideContainer() {
    this.widthSlideContainer = this.selectSlides().length * this.slideWidthWithGap - this.gap;
    this.slidesContainer.style.width = `${this.widthSlideContainer}px`;
  }
  selectSlides() {
    return this.carousel.querySelectorAll('.carousel-slide');
  }
  slidesToArray() {
    return Array.from(this.slides);
  }
  selectSlidesContainer() {
    return this.carousel.querySelector('.slides-container');
  }
  /**
   * Set number of dots
   * If infinite mode, one more window than normal mode.
   */
  setNumberDots() {
    if (this.loop) {
      return this.totalSlides === this.slideToShow ? 1 : this.totalSlides;
    }
    return this.slideToShow > 1 ? this.totalSlides - this.slideToShow + 1 : this.totalSlides;
  }
  /**
   * Get the max scrollable content
   * Useful for the streching effect (not infinite mode), end of the slides
   */
  getMaxScroll() {
    return (this.numberDots - 1) * this.slideWidthWithGap;
  }
  setDraggableImgToFalse() {
    const images = this.slidesContainer.querySelectorAll('img');
    images?.forEach(image => {
      image.setAttribute('draggable', 'false');
    });
  }
}
class Slider {
  constructor(carousel, responsive, slideToScroll, LIMIT_AUTO_SLIDE, strechingLimit, autoSlide, animationTimingFn, animationTimingMs, MAX_DOM_SIZE, enableMouseDrag, enableTouch, infinite, autoPlay, autoPlayInterval, autoPlayAtStart, playDirection, autoplaySlideToScroll, carouselService, cd) {
    this.carousel = carousel;
    this.responsive = responsive;
    this.slideToScroll = slideToScroll;
    this.LIMIT_AUTO_SLIDE = LIMIT_AUTO_SLIDE;
    this.strechingLimit = strechingLimit;
    this.autoSlide = autoSlide;
    this.animationTimingFn = animationTimingFn;
    this.animationTimingMs = animationTimingMs;
    this.MAX_DOM_SIZE = MAX_DOM_SIZE;
    this.enableMouseDrag = enableMouseDrag;
    this.enableTouch = enableTouch;
    this.infinite = infinite;
    this.autoPlay = autoPlay;
    this.autoPlayInterval = autoPlayInterval;
    this.autoPlayAtStart = autoPlayAtStart;
    this.playDirection = playDirection;
    this.autoplaySlideToScroll = autoplaySlideToScroll;
    this.carouselService = carouselService;
    this.cd = cd;
    this.dragging = false;
    this.currentSlide = 0;
    this.lastWindow = 0;
    this.currentTranslation = 0;
    this.previousTranslation = 0;
    this.direction = 'right';
    this.startX = 0;
    this.previousX = 0;
    this.currentX = 0;
    this.positionChange = 0;
    this.prevLimit = 0;
    this.nextLimit = 0;
    this.fullWidthInf = 0;
    this.lastWindowTranslation = 0;
    this.totalSlides = 0;
    this.DOMLimitReached = false;
    this.visibleOffsetCardNotResponsive = 0;
    this.invisibleOffsetCardNotResponsive = 0;
    this.accumulatedSlide = 0;
    this.currentCarouselID = 0;
    this.playActive = false;
    this.playButtonDisabled = false;
    this.directionAutoPlay = slides => {};
    this.initProperties();
    this.updateProperties();
    this.addSlidesToRightAtStart();
  }
  initProperties() {
    this.slidesContainer = this.carousel.slidesContainer;
    this.arrayOfSlides = this.carousel.arrayOfSlides;
    this.totalSlides = this.carousel.totalSlides;
    this.totalAmountOfSlides = this.totalSlides;
    this.nextLimit = Math.floor(this.carousel.slideWidthWithGap);
    this.prevLimit = -this.carousel.slideWidthWithGap;
    this.carouselService.carouselID += 1;
    this.currentCarouselID = this.carouselService.carouselID;
    this.defineAutoPlayDirection();
    if (this.autoPlayAtStart) this.launchAutoPlay();
    this.disableAutoPlayBtn();
  }
  /**
   * In finite carousel, clear autoPlay interval if limits are reached.
   */
  disableAutoPlayBtn() {
    if (!this.autoPlay || this.infinite) return;
    this.playButtonDisabled = false;
    // start
    if (this.currentSlide === 0 && this.playDirection === 'rtl' && this.currentTranslation === 0) {
      this.playButtonDisabled = true;
      this.playActive = false;
      clearInterval(this.autoInterval);
    }
    // end
    if (this.currentSlide === this.lastWindow && this.playDirection === 'ltr' && this.currentTranslation <= -this.carousel.maxScrollableContent) {
      this.playButtonDisabled = true;
      this.playActive = false;
      clearInterval(this.autoInterval);
    }
    if (this.carousel.numberDots === 1) this.playButtonDisabled = true;
  }
  defineAutoPlayDirection() {
    if (this.playDirection === 'ltr') {
      this.directionAutoPlay = this.next.bind(this);
    } else {
      this.directionAutoPlay = this.prev.bind(this);
    }
  }
  launchAutoPlay() {
    if (!this.autoPlay) return;
    this.playActive = true;
    this.autoInterval = window.setInterval(() => {
      this.directionAutoPlay(this.autoplaySlideToScroll);
      this.cd.markForCheck();
    }, this.autoPlayInterval);
  }
  stopAutoPlay() {
    if (!this.autoPlay) return;
    this.playActive = false;
    clearInterval(this.autoInterval);
  }
  /**
   * Update properties of the slider
   * Fired at start and at resizing.
   */
  updateProperties() {
    this.updateNotResponsive();
    this.lastWindow = this.carousel.numberDots - 1;
    this.fullWidthInf = this.totalSlides * this.carousel.slideWidthWithGap;
    this.lastWindowTranslation = this.slidesContainer.clientWidth - this.carousel.slideToShow * this.carousel.slideWidthWithGap + this.carousel.gap;
    this.lastWindowTranslation += this.responsive ? 0 : -this.visibleOffsetCardNotResponsive - this.carousel.gap;
    this.carousel.maxScrollableContent = this.carousel.widthSlideContainer - this.carousel.carouselWidth + this.carousel.paddingCarousel;
    if (this.carousel.numberDots === 1) {
      // if all slides visible in one window, max scrollable content equals 0
      this.carousel.maxScrollableContent = 0;
    }
  }
  updateNotResponsive() {
    if (this.responsive) return;
    // visible part of the offset of the card in px
    this.visibleOffsetCardNotResponsive = this.carousel.carouselWidth - this.carousel.slideToShow * this.carousel.slideWidthWithGap - this.carousel.paddingCarousel;
    this.invisibleOffsetCardNotResponsive = this.carousel.slideWidth - this.visibleOffsetCardNotResponsive;
  }
  /**
   * Add slides to the right at start
   * If only one window (number of dots === 1) and not responsive mode, there is possibly space at start for slides to the right (even though this configuration does not make a lot of sense)
   */
  addSlidesToRightAtStart() {
    if (this.carousel.numberDots > 1 || this.responsive || !this.infinite) {
      return;
    }
    this.addSlidesToTheRight();
  }
  /**
   * Fired at drag start
   * Instantiate property of the starting drag point on the X axis. Used to compute the translation.
   * Disabling the transition while applying the transformation because of the attached animation.
   */
  dragStart(event) {
    if (this.currentEventIsDisabled(event)) return;
    clearInterval(this.autoInterval);
    this.disableAutoPlayBtn();
    this.dragging = true;
    this.startX = event instanceof MouseEvent ? event.pageX : event.touches[0].pageX;
    // Useful for direction detection
    this.previousX = this.startX;
    this.slidesContainer.style.transition = 'none';
  }
  /**
   * Relaunch autoPlay if not disabled or infinite mode (never disabled by limits)
   * Restart only if started (playActive). Play button disabled when limits reached (finite carousel).
   */
  relaunchAutoPlay() {
    if ((!this.playButtonDisabled || this.infinite) && this.playActive) {
      clearInterval(this.autoInterval);
      this.launchAutoPlay();
    }
  }
  /**
   * Fired at drag end
   * If not infinite mode and limits reached (start or end), put back to the current slide. Updates previous translation.
   */
  dragStop(event) {
    if (this.currentEventIsDisabled(event)) return;
    this.dragging = false;
    this.previousTranslation = this.currentTranslation;
    if (this.autoSlide) this.autoSlider();
    this.disableAutoPlayBtn();
    if (this.infinite) return;
    const limit = this.currentTranslation > 0 || -this.currentTranslation > this.lastWindowTranslation;
    if (limit) {
      this.computeTransformation(this.currentSlide);
    }
  }
  currentEventIsDisabled(event) {
    return event instanceof MouseEvent && !this.enableMouseDrag || event instanceof TouchEvent && !this.enableTouch;
  }
  /**
   * Update the direction
   * Do not update the direction in case of the same previous position.
   */
  setDirection() {
    if (this.previousX > this.currentX) {
      this.direction = 'right';
    } else if (this.previousX < this.currentX) {
      this.direction = 'left';
    }
  }
  /**
   * Fired at dragging
   * Compute the translation, change the slide number, update the direction.
   */
  dragMove(event) {
    if (this.currentEventIsDisabled(event)) return;
    if (!this.dragging) return;
    this.currentX = event instanceof MouseEvent ? event.pageX : event.changedTouches[0].pageX;
    this.setDirection();
    this.previousX = this.currentX;
    this.positionChange = this.currentX - this.startX;
    this.currentTranslation = this.positionChange + this.previousTranslation;
    // Current translation exceeding start or end limits, finite mode
    if (!this.infinite) {
      if (this.strechingEffect()) return;
    }
    this.slidesContainer.style.transform = `translate3d(${this.currentTranslation}px, 0, 0)`;
    this.modifyCurrentSlide();
  }
  strechingEffect() {
    return this.currentTranslation > this.strechingLimit && this.currentSlide === 0 || this.currentTranslation < -this.carousel.maxScrollableContent - this.strechingLimit;
  }
  /**
   * Modify current slide
   * Take into account finite and infinite mode and auto slide.
   * Responsible for changing slide number and updating the limits.
   * If createSlidesInfiniteModeIfLimitsReached() doesn't take action, slide change according to previous computed limits.
   * In finite mode, if all slides visible on one window or end of carousel, early return to not trigger Rxjs Subject.
   */
  modifyCurrentSlide() {
    if (this.infinite) {
      if (this.createSlidesInfiniteModeIfLimits()) return;
    }
    if (!this.infinite && (this.carousel.numberDots === 1 || this.currentSlide === this.lastWindow && this.direction === 'right')) {
      return;
    }
    if (-this.currentTranslation < this.prevLimit) {
      this.changeSlideNumber(-1);
      this.decreaseLimits();
    } else if (-this.currentTranslation >= this.nextLimit) {
      this.changeSlideNumber(1);
      this.increaseLimits();
    }
  }
  /**
   * Handle slide creation in infinite mode if limits reached
   * Mouse or touch drag.
   */
  createSlidesInfiniteModeIfLimits() {
    if (this.currentTranslation > 0) {
      this.addSlidesToTheLeft();
      this.decreaseLimits(true);
      // not enabled at start
      if (this.currentSlide > 0) {
        this.changeSlideNumber(-1);
      }
      return true;
    } else if (-this.currentTranslation > this.lastWindowTranslation) {
      this.addSlidesToTheRight();
      if (this.DOMLimitReached) {
        this.changePrevAndNextLimits(this.accumulatedSlide);
        return true;
      }
    }
    return false;
  }
  /**
   * Auto slide card if option enabled, applied on both directions.
   * Prevents auto slide on limits in finite mode (if streching < limit auto slide).
   * If only one slide is displayed (slideToShow === 1), the width of the slide corresponds to the window's width (a dot). Hence, taking the min between the two.
   * In non responsive and non infinite, there is possibly an offset of the current limit.
   */
  autoSlider() {
    if (!this.infinite && (this.currentTranslation > 0 || -this.currentTranslation > this.lastWindowTranslation)) {
      return;
    }
    const referenceWidth = Math.min(this.carousel.slideWidth, this.carousel.slideMaxWidth || Infinity);
    let currentLimit = this.prevLimit + this.carousel.slideWidthWithGap;
    if (!this.responsive && !this.infinite && this.currentSlide > this.lastWindow - 1) {
      currentLimit = this.lastWindowTranslation;
    }
    // previousTranslation always a negative number, currentLimit always positive
    const currentPositionChange = this.previousTranslation + currentLimit;
    const moveComparedToSlide = currentPositionChange / referenceWidth * 100;
    if (moveComparedToSlide < -this.LIMIT_AUTO_SLIDE || moveComparedToSlide > this.LIMIT_AUTO_SLIDE) {
      if (moveComparedToSlide > this.LIMIT_AUTO_SLIDE) {
        this.changeSlideNumber(-1);
        this.decreaseLimits();
      } else {
        this.changeSlideNumber(1);
        this.increaseLimits();
        if (-this.currentTranslation > this.lastWindowTranslation && this.infinite) {
          this.addSlidesToTheRight();
        }
      }
      this.computeTransformation(this.accumulatedSlide);
    } else {
      // put back to current slide
      this.computeTransformation(this.accumulatedSlide);
    }
  }
  /**
   * Append or prepend new slides according to the direction
   * If new slides prepended, update the translation to the correct place (appending new slides do not change the translation).
   * Limit DOM growth or update last window translation if applicable.
   */
  appendOrPrependNElements() {
    if (this.direction === 'left') {
      for (let i = this.arrayOfSlides.length - 1; i >= 0; i--) {
        const clonedElement = this.arrayOfSlides[i].cloneNode(true);
        this.slidesContainer.prepend(clonedElement);
      }
      this.accumulatedSlide += this.totalSlides;
      this.resetViewLeftDirection();
    } else {
      for (let i = 0; i < this.arrayOfSlides.length; i++) {
        const clonedElement = this.arrayOfSlides[i].cloneNode(true);
        this.slidesContainer.append(clonedElement);
      }
    }
    if (this.totalAmountOfSlides >= this.MAX_DOM_SIZE * this.totalSlides) {
      // Limit DOM growth, max X times original DOM
      // console.log('dom limit reached');
      this.limitDOMGrowth();
      this.DOMLimitReached = true;
    } else {
      this.totalAmountOfSlides += this.totalSlides;
      this.DOMLimitReached = false;
      this.updateLastWindowTranslation();
    }
  }
  /**
   * Limit DOM growth
   * Reset the view accordingly.
   */
  limitDOMGrowth() {
    const slides = this.carousel.selectSlides();
    if (this.direction === 'right') {
      for (let i = 0; i < this.totalSlides; i++) {
        slides[i].remove();
      }
      this.resetViewRightDirection();
      this.accumulatedSlide -= this.totalSlides;
    } else {
      for (let i = slides.length - 1; i > slides.length - this.totalSlides - 1; i--) {
        slides[i].remove();
      }
    }
  }
  /**
   * Reset the view in a movement to the left
   * New slides added to the left, so the view has to be updated accordingly.
   * If the carousel is moved with the mouse | touch event (dragging is true), the offset should be equal to a full carousel width. Otherwise (with the buttons), the computed translation should be taken into account.
   * Side comment: the view does not have to be updated for slides added to the right, since relative order does not change.
   * getBoundingClientRect triggers reflow of the element.
   */
  resetViewLeftDirection() {
    let translation = Math.abs(this.previousTranslation) + this.fullWidthInf;
    this.previousTranslation = -translation;
    this.slidesContainer.style.transition = 'none';
    this.slidesContainer.style.transform = `translate3d(${this.dragging ? -this.fullWidthInf : -translation}px, 0px, 0px)`;
    // debugger;
    this.slidesContainer.getBoundingClientRect();
  }
  /**
   * Reset the view in a movement to the right
   * First set of slides have been deleted, so the translation has to be updated accordingly.
   * currentTranslation is a negative number so it will be decreased by a set of slides.
   * getBoundingClientRect triggers reflow of the element.
   */
  resetViewRightDirection() {
    let translation = this.currentTranslation + this.fullWidthInf;
    this.slidesContainer.style.transition = 'none';
    this.slidesContainer.style.transform = `translate3d(${translation}px, 0px, 0px)`;
    this.previousTranslation = translation - this.positionChange;
    this.slidesContainer.getBoundingClientRect();
  }
  /**
   * Update the last window translation
   * Useful to get the max translation at the end of the slides.
   * In not responsive mode, there is possibly a not fully displayed card (card offset).
   */
  updateLastWindowTranslation() {
    const total = this.totalAmountOfSlides * this.carousel.slideWidthWithGap;
    this.lastWindowTranslation = total - this.carousel.slideToShow * this.carousel.slideWidthWithGap;
    this.lastWindowTranslation += this.responsive ? 0 : -this.visibleOffsetCardNotResponsive - this.carousel.gap;
  }
  addSlidesToTheLeft() {
    this.appendOrPrependNElements();
  }
  addSlidesToTheRight() {
    this.appendOrPrependNElements();
  }
  /**
   * Decrease limit (movement to the left)
   * In infinite mode, take full width of a set if on the first slide as new slides are created to the left (a whole set offset).
   * Exception: if not responsive (card offset) and finite carousel, the next limit is at the maximum (the end of the carousel)
   */
  decreaseLimits(slidesCreatedOnTheLeft = false) {
    let translationCorrectionAfterClone = this.prevLimit;
    if (slidesCreatedOnTheLeft) {
      translationCorrectionAfterClone = this.fullWidthInf;
    }
    this.prevLimit = translationCorrectionAfterClone - this.carousel.slideWidthWithGap;
    this.nextLimit = this.prevLimit + 2 * this.carousel.slideWidthWithGap;
    if (!this.responsive && !this.infinite && this.currentSlide >= this.lastWindow - 1) {
      this.nextLimit = this.lastWindowTranslation;
    }
    this.prevLimit = Math.floor(this.prevLimit);
    this.nextLimit = Math.floor(this.nextLimit);
    // console.log(this.prevLimit, this.nextLimit);
  }
  /**
   * Increase limit on basis of previous computed limits (movement to the right)
   * Schema: || previous | current || next
   * Exception: if not responsive (card offset) and finite carousel, the next limit is at the maximum (the end of the carousel)
   */
  increaseLimits() {
    this.nextLimit += Math.floor(this.carousel.slideWidthWithGap);
    this.prevLimit = Math.floor(this.nextLimit - this.carousel.slideWidthWithGap * 2);
    if (!this.responsive && !this.infinite && this.currentSlide >= this.lastWindow - 1) {
      this.nextLimit = this.lastWindowTranslation;
      if (this.currentSlide === this.lastWindow) {
        // only update previous limit if last slide reached
        this.prevLimit = Math.floor(this.nextLimit - this.invisibleOffsetCardNotResponsive);
      }
    }
    // console.log(this.prevLimit, this.nextLimit);
  }
  /**
   * Change prev and next limit on basis of the provided slide number
   * Prev and next limit are always calculated as the following:
   * || <= prev | current || <= next
   */
  changePrevAndNextLimits(slideNumber) {
    const limitInPX = slideNumber * this.carousel.slideWidthWithGap;
    this.nextLimit = Math.floor(limitInPX + this.carousel.slideWidthWithGap);
    this.prevLimit = Math.floor(this.nextLimit - this.carousel.slideWidthWithGap * 2);
    // console.log(this.prevLimit, this.nextLimit);
  }
  /**
   * Previous button navigation
   */
  prev(slides = this.slideToScroll) {
    this.direction = 'left';
    if (this.infinite) {
      this.handleBtnInfinite(-slides);
    }
    this.changeSlideNumber(-slides);
    this.changePrevAndNextLimits(this.accumulatedSlide);
    this.computeTransformation(this.accumulatedSlide);
    this.disableAutoPlayBtn();
    this.relaunchAutoPlay();
  }
  /**
   * Next button navigation
   */
  next(slides = this.slideToScroll) {
    this.direction = 'right';
    if (this.infinite) {
      this.handleBtnInfinite(slides);
    }
    this.changeSlideNumber(slides);
    this.changePrevAndNextLimits(this.accumulatedSlide);
    this.computeTransformation(this.accumulatedSlide);
    this.disableAutoPlayBtn();
    this.relaunchAutoPlay();
  }
  /**
   * Buttons navigation in infinite mode
   * Create new slide if limits reached (start or end). Update slide, limits and apply transformation accordingly.
   */
  handleBtnInfinite(step) {
    let cardOffset = 0;
    const goingTo = this.accumulatedSlide + step;
    // there is (possibly) a card offset if not responsive
    if (!this.responsive) cardOffset = 1;
    if (goingTo < 0) {
      this.addSlidesToTheLeft();
    } else if (goingTo + this.carousel.slideToShow + cardOffset > this.totalAmountOfSlides) {
      this.addSlidesToTheRight();
    }
  }
  /**
   * Navigation with bullet points
   * Update values accordingly.
   */
  goTo(bullet) {
    this.direction = this.currentSlide < bullet ? 'right' : 'left';
    this.currentSlide = bullet;
    this.carouselService.onChange(this.currentSlide, this.currentCarouselID);
    this.disableAutoPlayBtn();
    this.relaunchAutoPlay();
    if (this.infinite) {
      this.navInfiniteBullets(bullet);
      return;
    }
    this.accumulatedSlide = this.currentSlide;
    this.changePrevAndNextLimits(bullet);
    this.computeTransformation(bullet);
  }
  /**
   * Bullets navigation
   * Create new slides if exceeding end of carousel.
   */
  navInfiniteBullets(bullet) {
    let cardOffset = 0;
    const positionOfCurrentSlide = this.accumulatedSlide % this.totalSlides;
    const difference = bullet - positionOfCurrentSlide;
    this.accumulatedSlide += difference;
    // there is (possibly) a card offset if not responsive
    if (!this.responsive) cardOffset = 1;
    if (this.accumulatedSlide + this.carousel.slideToShow + cardOffset > this.totalAmountOfSlides) {
      this.addSlidesToTheRight();
    }
    this.computeTransformation(this.accumulatedSlide);
    this.changePrevAndNextLimits(this.accumulatedSlide);
  }
  /**
   * Responsible for changing slide number in finite and infinite mode
   * Exception: if only one window (numberDots === 1), update the accumulatedSlide to let the transformation occurs, but currentSlide should stay at 0.
   */
  changeSlideNumber(step) {
    if (this.infinite) {
      this.infiniteChangeSlideNumber(step);
    } else {
      this.finiteChangeSlideNumber(step);
    }
    if (this.carousel.numberDots === 1) {
      this.currentSlide = 0;
    }
    const current = this.carousel.numberDots > 1 ? this.currentSlide : this.accumulatedSlide;
    this.carouselService.onChange(current, this.currentCarouselID);
  }
  infiniteChangeSlideNumber(step) {
    this.accumulatedSlide += step;
    this.currentSlide += step;
    if (this.currentSlide > this.lastWindow) {
      const surplus = this.currentSlide % this.lastWindow;
      this.currentSlide = surplus - 1;
    } else if (this.currentSlide < 0) {
      const surplus = this.currentSlide % this.lastWindow;
      this.currentSlide = this.totalSlides + surplus;
    }
  }
  finiteChangeSlideNumber(step) {
    this.currentSlide += step;
    if (this.currentSlide > this.lastWindow) {
      this.currentSlide = this.lastWindow;
    } else if (this.currentSlide < 0) {
      this.currentSlide = 0;
    }
    this.accumulatedSlide = this.currentSlide;
  }
  /**
   * Compute transformation that will be applied on basis of the provided slide number
   * Exception: if not responsive (card offset) and finite carousel, the next limit is the end of the carousel
   */
  computeTransformation(slide) {
    let transformation = slide * this.carousel.slideWidthWithGap;
    if (!this.responsive && !this.infinite && slide >= this.lastWindow - 1 && this.carousel.numberDots > 1) {
      this.nextLimit = this.lastWindowTranslation;
      if (slide === this.lastWindow) {
        // if last window, go to maximum & update prev limit
        transformation = this.lastWindowTranslation;
        this.prevLimit = Math.floor(this.nextLimit - this.invisibleOffsetCardNotResponsive);
      }
    }
    this.applyTransformation(transformation);
  }
  applyTransformation(transformation) {
    this.slidesContainer.style.transition = `transform ${this.animationTimingMs}ms ${this.animationTimingFn}`;
    this.slidesContainer.style.transform = `translate3d(${-transformation}px, 0px, 0px)`;
    this.dragging = false;
    this.previousTranslation = -transformation;
    this.currentTranslation = -transformation;
  }
}
class Validation {
  constructor(carousel, slideWidth, slideMaxWidth, gap, slideToScroll) {
    this.carousel = carousel;
    this.slideWidth = slideWidth;
    this.slideMaxWidth = slideMaxWidth;
    this.gap = gap;
    this.slideToScroll = slideToScroll;
    this.carouselSlides = this.carousel.querySelectorAll('.carousel-slide');
    this.slideMaxWidthShouldBeGreaterThanSlideWidth();
    this.slideWidthAndGapShouldBeGreaterThanZero();
    this.requiredClassShouldBeAdded();
    this.slideToScrollNotGreaterThanTotalSlides();
  }
  slideMaxWidthShouldBeGreaterThanSlideWidth() {
    if (this.slideMaxWidth < this.slideWidth) {
      throw new Error(`slideMaxWidth (value: ${this.slideMaxWidth}) is lower than slideWidth (value: ${this.slideWidth}). Please increase the max width or decrease the slide width.`);
    }
  }
  slideWidthAndGapShouldBeGreaterThanZero() {
    const slideWidthPlusGap = this.slideWidth + this.gap;
    if (slideWidthPlusGap <= 0) {
      throw new Error('Unable to construct Carousel. SlideWidth and gap lower or equal than zero. Please add a positive value for the slideWidth and gap.');
    }
  }
  slideToScrollNotGreaterThanTotalSlides() {
    if (this.carouselSlides && this.slideToScroll > this.carouselSlides.length) {
      throw new Error('slideToScroll value is greater than the total amount of slide. This can cause invisible cards in infinite mode. Please lower the slideToScroll value.');
    }
  }
  requiredClassShouldBeAdded() {
    if (this.carouselSlides === undefined || this.carouselSlides.length === 0) {
      throw new Error('No elements with "carousel-slide" as class have been found. Please add this class to each of your slides.');
    }
  }
}
class CarouselService {
  constructor() {
    /**
     * An RXJS Subject that will be triggered at every slide change. Returns an object containing the zero indexed current slide number and the zero indexed carousel ID.
     */
    this.onSlideChange = new Subject();
    /**
     * Internal use only.
     */
    this.carouselID = -1;
  }
  /**
   * Internal use only.
   */
  onChange(slide, currentCarouselID) {
    this.onSlideChange.next({
      slide,
      carouselID: currentCarouselID
    });
  }
  static {
    this.ɵfac = function CarouselService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CarouselService,
      factory: CarouselService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class CarouselComponent {
  constructor(cd, carouselService, platformId) {
    this.cd = cd;
    this.carouselService = carouselService;
    this.infinite = false;
    this.responsive = true;
    this.autoSlide = true;
    this.slideToShow = 3;
    this.slideToScroll = 2;
    this.autoslideLimitPercentCard = 30;
    this.strechingLimit = 60;
    this.slideWidth = 300;
    this.slideMaxWidth = 500;
    this.dots = true;
    this.arrows = true;
    this.counter = true;
    this.enableMouseDrag = true;
    this.enableTouch = true;
    this.counterSeparator = '/';
    this.gapBetweenSlides = 16;
    this.animationTimingMs = 300;
    this.maxDomSize = 4;
    this.animationTimingFn = 'ease-out';
    this.autoPlay = false;
    this.autoPlayInterval = 1500;
    this.autoPlayAtStart = false;
    this.displayAutoPlayControls = true;
    this.autoPlaySlideToScroll = 1;
    this.autoPlayDirection = 'ltr';
    this.isBrowser = true;
    this.isBrowser = isPlatformBrowser(platformId);
  }
  ngAfterViewInit() {
    if (!this.isBrowser) return;
    const carouselContainer = this.carouselContainer.nativeElement;
    new Validation(carouselContainer, this.slideWidth, this.slideMaxWidth, this.gapBetweenSlides, this.slideToScroll);
    this.carousel = new Carousel(carouselContainer, this.maxWidthCarousel, this.slideToShow, this.slideWidth, this.slideMaxWidth, this.gapBetweenSlides, this.responsive, this.infinite);
    this.slider = new Slider(this.carousel, this.responsive, this.slideToScroll, this.autoslideLimitPercentCard, this.strechingLimit, this.autoSlide, this.animationTimingFn, this.animationTimingMs, this.maxDomSize, this.enableMouseDrag, this.enableTouch, this.infinite, this.autoPlay, this.autoPlayInterval, this.autoPlayAtStart, this.autoPlayDirection, this.autoPlaySlideToScroll, this.carouselService, this.cd);
    this.listeners();
    this.cd.detectChanges();
  }
  listeners() {
    this.mouseupSubscription = fromEvent(window, 'mouseup').subscribe(event => {
      if (!this.slider.dragging) return;
      this.slider.dragStop(event);
      this.slider.relaunchAutoPlay();
      this.cd.markForCheck();
    });
    // User navigate away/comes back
    this.VChangeSubscription = fromEvent(document, 'visibilitychange').subscribe(event => {
      const visibility = event.target.visibilityState;
      this.slider.dragStop(event);
      if (visibility === 'hidden') {
        clearInterval(this.slider.autoInterval);
      }
      if (visibility === 'visible') {
        this.slider.relaunchAutoPlay();
      }
      this.cd.markForCheck();
    });
    this.resizeSubscription = fromEvent(window, 'resize').subscribe(() => {
      this.resize();
    });
  }
  /**
   * Reinitialise variables at resize
   */
  resize() {
    if (!this.slider || !this.carousel) return;
    this.carousel.updateProperties();
    this.slider.updateProperties();
    this.slider.stopAutoPlay();
    this.slider.currentSlide = 0;
    this.slider.accumulatedSlide = 0;
    this.slider.computeTransformation(0);
    this.slider.changePrevAndNextLimits(0);
    this.carouselService.onChange(this.slider.currentSlide, this.slider.currentCarouselID);
    this.cd.markForCheck();
  }
  /**
   * Removes active subscriptions and clear interval autoplay.
   */
  ngOnDestroy() {
    this.mouseupSubscription?.unsubscribe();
    this.VChangeSubscription?.unsubscribe();
    this.resizeSubscription?.unsubscribe();
    this.slider?.stopAutoPlay();
  }
  static {
    this.ɵfac = function CarouselComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CarouselService), i0.ɵɵdirectiveInject(PLATFORM_ID));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CarouselComponent,
      selectors: [["carousel"]],
      viewQuery: function CarouselComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.carouselContainer = _t.first);
        }
      },
      inputs: {
        maxWidthCarousel: "maxWidthCarousel",
        infinite: "infinite",
        responsive: "responsive",
        autoSlide: "autoSlide",
        slideToShow: "slideToShow",
        slideToScroll: "slideToScroll",
        autoslideLimitPercentCard: "autoslideLimitPercentCard",
        strechingLimit: "strechingLimit",
        slideWidth: "slideWidth",
        slideMaxWidth: "slideMaxWidth",
        dots: "dots",
        arrows: "arrows",
        counter: "counter",
        enableMouseDrag: "enableMouseDrag",
        enableTouch: "enableTouch",
        counterSeparator: "counterSeparator",
        gapBetweenSlides: "gapBetweenSlides",
        animationTimingMs: "animationTimingMs",
        maxDomSize: "maxDomSize",
        animationTimingFn: "animationTimingFn",
        autoPlay: "autoPlay",
        autoPlayInterval: "autoPlayInterval",
        autoPlayAtStart: "autoPlayAtStart",
        displayAutoPlayControls: "displayAutoPlayControls",
        autoPlaySlideToScroll: "autoPlaySlideToScroll",
        autoPlayDirection: "autoPlayDirection"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 9,
      vars: 6,
      consts: [["carouselContainer", ""], [1, "carousel-container"], [1, "banner-container"], [1, "btn-container"], [1, "autoplay-container"], [1, "counter"], [1, "slides-container", 3, "mousedown", "touchstart", "mousemove", "touchmove", "touchend"], [1, "bullets-container"], ["aria-label", "previous button navigation", 1, "prev", 3, "click", "disabled"], ["xmlns", "http://www.w3.org/2000/svg", "height", "16", "width", "16", "viewBox", "0 0 512 512"], ["d", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"], ["aria-label", "next button navigation", 1, "next", 3, "click", "disabled"], ["d", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"], ["aria-label", "play button navigation", 1, "play", 3, "click", "disabled"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 384 512"], ["d", "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"], ["aria-label", "pause button navigation", 1, "pause", 3, "click", "disabled"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 320 512"], ["d", "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"], ["class", "bullet", "aria-label", "bullet point navigation", 3, "current", "click", 4, "ngFor", "ngForOf"], ["aria-label", "bullet point navigation", 1, "bullet", 3, "click"]],
      template: function CarouselComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 1, 0)(2, "div", 2);
          i0.ɵɵtemplate(3, CarouselComponent_Conditional_3_Template, 7, 2, "div", 3)(4, CarouselComponent_Conditional_4_Template, 7, 2, "div", 4)(5, CarouselComponent_Conditional_5_Template, 3, 3, "div", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 6);
          i0.ɵɵlistener("mousedown", function CarouselComponent_Template_div_mousedown_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.slider == null ? null : ctx.slider.dragStart($event));
          })("touchstart", function CarouselComponent_Template_div_touchstart_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.slider == null ? null : ctx.slider.dragStart($event));
          })("mousemove", function CarouselComponent_Template_div_mousemove_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.slider == null ? null : ctx.slider.dragMove($event));
          })("touchmove", function CarouselComponent_Template_div_touchmove_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.slider == null ? null : ctx.slider.dragMove($event));
          })("touchend", function CarouselComponent_Template_div_touchend_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            ctx.slider == null ? null : ctx.slider.dragStop($event);
            return i0.ɵɵresetView(ctx.slider == null ? null : ctx.slider.relaunchAutoPlay());
          });
          i0.ɵɵprojection(7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, CarouselComponent_Conditional_8_Template, 2, 1, "div", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.arrows ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.autoPlay && ctx.displayAutoPlayControls ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.counter ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("dragging", ctx.slider == null ? null : ctx.slider.dragging);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.dots ? 8 : -1);
        }
      },
      dependencies: [CommonModule, i2.NgForOf],
      styles: ["*[_ngcontent-%COMP%]{margin:0;padding:0;box-sizing:border-box}.carousel-container[_ngcontent-%COMP%]{position:relative;overflow-x:hidden;padding:.2rem}.slides-container[_ngcontent-%COMP%]{display:grid;grid-auto-flow:column;justify-items:center;transform:translateZ(0);margin:auto}.banner-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:.5rem}.btn-container[_ngcontent-%COMP%]{min-width:3.75rem}.autoplay-container[_ngcontent-%COMP%]{display:flex;gap:1rem}.autoplay-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:none;background:none;display:flex;cursor:pointer}.autoplay-container[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#3b3b3b;width:1.8rem;height:1.8rem;transition:fill .3s}.play[_ngcontent-%COMP%]:disabled   svg[_ngcontent-%COMP%], .pause[_ngcontent-%COMP%]:disabled   svg[_ngcontent-%COMP%]{fill:#b1b1b1;cursor:not-allowed}.counter[_ngcontent-%COMP%]{background:#e6e6e6;padding:.3rem .7rem;border-radius:1rem;min-width:3.75rem;text-align:center}.prev[_ngcontent-%COMP%], .next[_ngcontent-%COMP%]{background:#0079b4;padding:.5rem;color:#fff;border-radius:.3rem;box-shadow:0 2px 4px #9e9e9ed4;border:none;cursor:pointer;z-index:1;transition:.4s}.prev[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .next[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff}.prev[_ngcontent-%COMP%], .next[_ngcontent-%COMP%]{display:inline-flex;align-items:center;justify-content:center}.prev[_ngcontent-%COMP%]{margin-right:1rem}.prev[_ngcontent-%COMP%]:disabled, .next[_ngcontent-%COMP%]:disabled{opacity:.3;cursor:not-allowed}.bullets-container[_ngcontent-%COMP%]{display:flex;justify-content:center;gap:1rem;margin-top:2rem}.bullet[_ngcontent-%COMP%]{display:block;width:.8rem;height:.8rem;border:none;border-radius:50%;background:#dbdada;cursor:pointer;transition:background-color .4s}.bullet.current[_ngcontent-%COMP%]{background:#0079b4}.slides-container.dragging[_ngcontent-%COMP%]{cursor:grab}@media (min-width: 650px){.prev[_ngcontent-%COMP%], .next[_ngcontent-%COMP%]{position:absolute;top:50%;left:0;transform:translateY(-50%)}.prev[_ngcontent-%COMP%]{margin-left:2rem}.next[_ngcontent-%COMP%]{margin-right:2rem;right:0;left:auto}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselComponent, [{
    type: Component,
    args: [{
      selector: 'carousel',
      imports: [CommonModule],
      standalone: true,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"carousel-container\" #carouselContainer>\r\n  <div class=\"banner-container\">\r\n    @if (arrows) {\r\n    <div class=\"btn-container\">\r\n      <button\r\n        class=\"prev\"\r\n        aria-label=\"previous button navigation\"\r\n        (click)=\"slider?.prev()\"\r\n        [disabled]=\"\r\n          !infinite &&\r\n          ((slider?.currentSlide === 0 &&\r\n            (slider?.currentTranslation || 0) >= 0) ||\r\n            carousel?.numberDots === 1)\r\n        \"\r\n      >\r\n        <svg\r\n          xmlns=\"http://www.w3.org/2000/svg\"\r\n          height=\"16\"\r\n          width=\"16\"\r\n          viewBox=\"0 0 512 512\"\r\n        >\r\n          <path\r\n            d=\"M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z\"\r\n          />\r\n        </svg>\r\n      </button>\r\n      <button\r\n        class=\"next\"\r\n        aria-label=\"next button navigation\"\r\n        (click)=\"slider?.next()\"\r\n        [disabled]=\"\r\n          !infinite &&\r\n          ((slider?.currentSlide === (carousel?.numberDots || 0) - 1 &&\r\n            (slider?.currentTranslation || 0) <=\r\n              -(carousel?.maxScrollableContent || 0)) ||\r\n            carousel?.numberDots === 1)\r\n        \"\r\n      >\r\n        <svg\r\n          xmlns=\"http://www.w3.org/2000/svg\"\r\n          height=\"16\"\r\n          width=\"16\"\r\n          viewBox=\"0 0 512 512\"\r\n        >\r\n          <path\r\n            d=\"M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z\"\r\n          />\r\n        </svg>\r\n      </button>\r\n    </div>\r\n    } @if (autoPlay && displayAutoPlayControls) {\r\n    <div class=\"autoplay-container\">\r\n      <button\r\n        class=\"play\"\r\n        [disabled]=\"slider?.playActive || slider?.playButtonDisabled\"\r\n        (click)=\"slider?.launchAutoPlay()\"\r\n        aria-label=\"play button navigation\"\r\n      >\r\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\">\r\n          <path\r\n            d=\"M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z\"\r\n          />\r\n        </svg>\r\n      </button>\r\n      <button\r\n        class=\"pause\"\r\n        [disabled]=\"!slider?.playActive\"\r\n        (click)=\"slider?.stopAutoPlay()\"\r\n        aria-label=\"pause button navigation\"\r\n      >\r\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\">\r\n          <path\r\n            d=\"M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z\"\r\n          />\r\n        </svg>\r\n      </button>\r\n    </div>\r\n    } @if (counter) {\r\n    <div class=\"counter\">\r\n      <p>\r\n        {{ (slider?.currentSlide || 0) + 1 }} {{ counterSeparator }}\r\n        {{ carousel?.numberDots }}\r\n      </p>\r\n    </div>\r\n    }\r\n  </div>\r\n\r\n  <div\r\n    class=\"slides-container\"\r\n    [class.dragging]=\"slider?.dragging\"\r\n    (mousedown)=\"slider?.dragStart($event)\"\r\n    (touchstart)=\"slider?.dragStart($event)\"\r\n    (mousemove)=\"slider?.dragMove($event)\"\r\n    (touchmove)=\"slider?.dragMove($event)\"\r\n    (touchend)=\"slider?.dragStop($event); this.slider?.relaunchAutoPlay()\"\r\n  >\r\n    <ng-content></ng-content>\r\n  </div>\r\n\r\n  @if (dots) {\r\n  <div class=\"bullets-container\">\r\n    <button\r\n      class=\"bullet\"\r\n      aria-label=\"bullet point navigation\"\r\n      *ngFor=\"let bullet of carousel?.arrayNumberDots\"\r\n      [class.current]=\"bullet === slider?.currentSlide\"\r\n      (click)=\"slider?.goTo(bullet)\"\r\n    ></button>\r\n  </div>\r\n  }\r\n</div>\r\n",
      styles: ["*{margin:0;padding:0;box-sizing:border-box}.carousel-container{position:relative;overflow-x:hidden;padding:.2rem}.slides-container{display:grid;grid-auto-flow:column;justify-items:center;transform:translateZ(0);margin:auto}.banner-container{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:.5rem}.btn-container{min-width:3.75rem}.autoplay-container{display:flex;gap:1rem}.autoplay-container button{border:none;background:none;display:flex;cursor:pointer}.autoplay-container svg{fill:#3b3b3b;width:1.8rem;height:1.8rem;transition:fill .3s}.play:disabled svg,.pause:disabled svg{fill:#b1b1b1;cursor:not-allowed}.counter{background:#e6e6e6;padding:.3rem .7rem;border-radius:1rem;min-width:3.75rem;text-align:center}.prev,.next{background:#0079b4;padding:.5rem;color:#fff;border-radius:.3rem;box-shadow:0 2px 4px #9e9e9ed4;border:none;cursor:pointer;z-index:1;transition:.4s}.prev svg,.next svg{fill:#fff}.prev,.next{display:inline-flex;align-items:center;justify-content:center}.prev{margin-right:1rem}.prev:disabled,.next:disabled{opacity:.3;cursor:not-allowed}.bullets-container{display:flex;justify-content:center;gap:1rem;margin-top:2rem}.bullet{display:block;width:.8rem;height:.8rem;border:none;border-radius:50%;background:#dbdada;cursor:pointer;transition:background-color .4s}.bullet.current{background:#0079b4}.slides-container.dragging{cursor:grab}@media (min-width: 650px){.prev,.next{position:absolute;top:50%;left:0;transform:translateY(-50%)}.prev{margin-left:2rem}.next{margin-right:2rem;right:0;left:auto}}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: CarouselService
  }, {
    type: Object,
    decorators: [{
      type: Inject,
      args: [PLATFORM_ID]
    }]
  }], {
    maxWidthCarousel: [{
      type: Input
    }],
    infinite: [{
      type: Input
    }],
    responsive: [{
      type: Input
    }],
    autoSlide: [{
      type: Input
    }],
    slideToShow: [{
      type: Input
    }],
    slideToScroll: [{
      type: Input
    }],
    autoslideLimitPercentCard: [{
      type: Input
    }],
    strechingLimit: [{
      type: Input
    }],
    slideWidth: [{
      type: Input
    }],
    slideMaxWidth: [{
      type: Input
    }],
    dots: [{
      type: Input
    }],
    arrows: [{
      type: Input
    }],
    counter: [{
      type: Input
    }],
    enableMouseDrag: [{
      type: Input
    }],
    enableTouch: [{
      type: Input
    }],
    counterSeparator: [{
      type: Input
    }],
    gapBetweenSlides: [{
      type: Input
    }],
    animationTimingMs: [{
      type: Input
    }],
    maxDomSize: [{
      type: Input
    }],
    animationTimingFn: [{
      type: Input
    }],
    autoPlay: [{
      type: Input
    }],
    autoPlayInterval: [{
      type: Input
    }],
    autoPlayAtStart: [{
      type: Input
    }],
    displayAutoPlayControls: [{
      type: Input
    }],
    autoPlaySlideToScroll: [{
      type: Input
    }],
    autoPlayDirection: [{
      type: Input
    }],
    carouselContainer: [{
      type: ViewChild,
      args: ['carouselContainer']
    }]
  });
})();
class CarouselModule {
  static {
    this.ɵfac = function CarouselModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CarouselModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, CarouselComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselModule, [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [CommonModule, CarouselComponent],
      exports: [CarouselComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of carousel
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CarouselComponent, CarouselModule, CarouselService };
